import { Component, inject, OnDestroy, OnInit, output } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-table-filter-currency',
  imports: [InputTextModule, ReactiveFormsModule],
  templateUrl: './table-filter-currency.component.html',
  styleUrls: ['./table-filter-currency.component.scss'],
})
export class TableFilterCurrencyComponent implements OnInit, OnDestroy {
  private readonly builder = inject(FormBuilder);

  public readonly changes = output<number>();

  public control!: FormControl<number>;

  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.configureControl();
    this.configureValueChangesSource();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private configureControl(): void {
    this.control = this.builder.nonNullable.control(0);
  }

  private configureValueChangesSource(): void {
    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => this.changes.emit(value));
  }
}
